module.exports = __webpack_public_path__ + "static/media/findhotel-logo-compact.53feb60c.svg";